// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tonForm {
  margin-top: 2%;
  padding-top: 1%;
  padding-left: 7%;
  padding-bottom: 7%;
}

.ligne1 {
  display: flex;
  gap: 3%;
}

.password {
  margin-left: 3%;
}

.ligne2 {
  display: flex;
  gap: 3%;
  margin-top: 3%;
}

.ligne3 {
  display: flex;
  gap: 3%;
  margin-top: 1%;
}

.ligne2bis {
  display: flex;
  gap: 3%;
  margin-top: 3%;
}

.ligne4bis {
  display: flex;
  gap: 3%;
  margin-top: 3%;
}

.enfer {
  display: flex;
  flex-direction: column;
}

.ligne4 {
  margin-top: 3%;
  margin-left: 23%;
}

.inputDocDes {
  width: 100%;
}

.realHell {
  margin-top: 4%;
}

.smallMarginTop {
  margin-top: 1%;
}

/* .newContain{
    display: flex;


  margin-left: 15%;
    flex-direction: column;
   margin-top: 10%;


}

.row-1{
    display:flex;
}

.row-2{
    display:flex;
    // align-items: baseline;
   // gap: 3%;
    margin-top: 1%;
    flex-direction: row;

} */
/* 
.row-2bis{

    margin-top: 3%;
    display: flex;
    flex-direction: column;
    gap: 13%;


} */
/* .row-2bis > * {
    margin-bottom: 10px;
  } */
/* 
 .dialog-box{
    display: flex;
    //gap:3%;
} 



.inputDoc{
    height: min-content;
    width: 900%;
    margin-left: 30px !important;
}

.desDoc{
    margin-left: 100px !important;
    width: 1500%;
}

.column1{
  //  background-color: rgb(117, 115, 115);
    width: 400px;
    display: flex;
    flex-direction: column;
    gap: 10%;
}

.column2{
    width: 400px;
    display: flex;
    flex-direction: column;
    // background-color: red;




}

.firstName, .lastName{
    display:flex;
    gap:15%;
    margin-bottom: 2%;
}

.program{
    display:flex;
    gap:19%;
    margin-top: 4%;
}

.email{
    display:flex;
    gap:25%;
} */
/* .documents{
    display:flex;
    gap:3%;
} */
/* 
.sub-btn{
    width:70px;
    margin-left: 300px;
}

.success{
    color:green;
}

.add-btn{
    height: 50%;
    width:100%;

}

.mala{
    height: 50%;
    width:50%;
    margin-left: 100px !important;

} */`, "",{"version":3,"sources":["webpack://./src/pages/CreateClient/CreateClient.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,OAAA;AACJ;;AAGA;EACI,eAAA;AAAJ;;AAKA;EACI,aAAA;EACA,OAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,OAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,OAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,OAAA;EACA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;AAFJ;;AAOA;EACI,cAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;;AAQA;EACI,cAAA;AALJ;;AAQA;EACI,cAAA;AALJ;;AAyCA;;;;;;;;;;;;;;;;;;;;;;GAAA;AA2BA;;;;;;;;;GAAA;AAWA;;KAAA;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAuDA;;;GAAA;AAIA;;;;;;;;;;;;;;;;;;;;;GAAA","sourcesContent":[".tonForm{\n    margin-top: 2%;\n    padding-top: 1%;\n    padding-left: 7%;\n    padding-bottom: 7%;\n}\n\n.ligne1{\n    display: flex;\n    gap:3%;\n\n}\n\n.password{\n    margin-left: 3%;\n\n}\n\n\n.ligne2{\n    display: flex;\n    gap:3%;\n    margin-top: 3%;\n}\n\n.ligne3{\n    display: flex;\n    gap:3%;\n    margin-top: 1%;\n}\n\n.ligne2bis{\n    display: flex;\n    gap:3%;\n    margin-top: 3%;\n}\n\n.ligne4bis{\n    display: flex;\n    gap:3%;\n    margin-top: 3%;\n}\n\n.enfer{\n    display: flex;\n    flex-direction: column;\n   \n}\n\n\n.ligne4{\n    margin-top: 3%;\n    margin-left:23%;\n}\n\n.inputDocDes{\n    width: 100%;\n    \n}\n\n.realHell{\n    margin-top: 4%;\n}\n\n.smallMarginTop{\n    margin-top: 1%;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* .newContain{\n    display: flex;\n  \n  \n  margin-left: 15%;\n    flex-direction: column;\n   margin-top: 10%;\n  \n\n}\n\n.row-1{\n    display:flex;\n}\n\n.row-2{\n    display:flex;\n    // align-items: baseline;\n   // gap: 3%;\n    margin-top: 1%;\n    flex-direction: row;\n  \n} */\n\n// Then, we use the > selector to target all immediate children of the row-2bis class and add margin-bottom: 10px\n//  to give each row a margin at the bottom\n\n/* \n.row-2bis{\n\n    margin-top: 3%;\n    display: flex;\n    flex-direction: column;\n    gap: 13%;\n\n\n} */\n\n/* .row-2bis > * {\n    margin-bottom: 10px;\n  } */\n\n/* \n .dialog-box{\n    display: flex;\n    //gap:3%;\n} \n\n\n\n.inputDoc{\n    height: min-content;\n    width: 900%;\n    margin-left: 30px !important;\n}\n\n.desDoc{\n    margin-left: 100px !important;\n    width: 1500%;\n}\n\n.column1{\n  //  background-color: rgb(117, 115, 115);\n    width: 400px;\n    display: flex;\n    flex-direction: column;\n    gap: 10%;\n}\n\n.column2{\n    width: 400px;\n    display: flex;\n    flex-direction: column;\n    // background-color: red;\n    \n\n\n    \n}\n\n.firstName, .lastName{\n    display:flex;\n    gap:15%;\n    margin-bottom: 2%;\n}\n\n.program{\n    display:flex;\n    gap:19%;\n    margin-top: 4%;\n}\n\n.email{\n    display:flex;\n    gap:25%;\n} */\n\n/* .documents{\n    display:flex;\n    gap:3%;\n} */\n/* \n.sub-btn{\n    width:70px;\n    margin-left: 300px;\n}\n\n.success{\n    color:green;\n}\n\n.add-btn{\n    height: 50%;\n    width:100%;\n \n}\n\n.mala{\n    height: 50%;\n    width:50%;\n    margin-left: 100px !important;\n  \n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
